import { IPreloadedState } from 'shared/types/redux';

export const selectFiltersAvailability = (state: IPreloadedState) => state.marketTrends.filtersAvailability;
